import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const KeyJ = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.86515 16C1.03658 16 0.104004 15.0852 0.104004 13.2739V2.71698C0.104004 0.914809 1.03658 0 2.86515 0H13.352C15.1806 0 16.104 0.914809 16.104 2.71698V13.2739C16.104 15.0852 15.1806 16 13.352 16H2.86515ZM2.91086 14.5089H13.2971C14.1383 14.5089 14.6137 14.0606 14.6137 13.1824V2.81761C14.6137 1.93939 14.1383 1.49114 13.2971 1.49114H2.91086C2.06972 1.49114 1.60343 1.93939 1.60343 2.81761V13.1824C1.60343 14.0606 2.06972 14.5089 2.91086 14.5089ZM7.69258 12.0297C6.48572 12.0297 5.52572 11.4351 5.224 10.5203C5.17829 10.3831 5.16 10.255 5.16 10.1086C5.16 9.70612 5.43429 9.42253 5.83658 9.42253C6.15658 9.42253 6.35772 9.5689 6.51315 9.91652C6.71429 10.4563 7.13486 10.7673 7.75658 10.7673C8.45143 10.7673 8.88115 10.2733 8.88115 9.42253V4.70212C8.88115 4.20812 9.13715 3.86964 9.60343 3.86964C10.088 3.86964 10.3531 4.18982 10.3531 4.70212V9.44997C10.3531 11.1058 9.42058 12.0297 7.69258 12.0297Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
